// @ts-nocheck
/* eslint-disable @typescript-eslint/no-unsafe-return, react-hooks/exhaustive-deps, @typescript-eslint/no-unused-vars */

import { useCallback } from 'react';
import { prevBusinessDay } from '../../util';
import { fetchAPI } from '../../util/shared/fetch';
import useLog from '../useLog';

const useConcentration = () => {
  const { fetchAPIWithLog } = useLog('useConcentration');

  const getConcentrationByExp = useCallback(async (syms: string) => {
    return await fetchAPIWithLog(
      `v1/concentration?syms=${syms}&groupBy=expiration`,
    );
  }, []);

  const getConcentrationByStrike = useCallback(async (syms: string) => {
    return await fetchAPIWithLog(
      `v1/concentration?syms=${syms}&groupBy=strike`,
    );
  }, []);

  return { getConcentrationByExp, getConcentrationByStrike };
};

export default useConcentration;
